import { apiClient, apiDelete, apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const projectsApi = {
  listProjects:    (params) => apiGet('/api/projects/projects', params),
  getProject:      (id)     => apiGet(`/api/projects/projects/${id}`),
  createProject:   (body)   => apiPost('/api/projects/projects', body),
  updateProject:   (id, body) => apiPut(`/api/projects/projects/${id}`, body),
  setProjectStatus:(id, status) => apiPatch(`/api/projects/projects/${id}/status`, { status }),
  billingPreview:  (id)       => apiGet(`/api/projects/projects/${id}/billing-preview`),
  markProjectBilled:(id, body) => apiPost(`/api/projects/projects/${id}/billing`, body),

  listTasks:       (id)     => apiGet(`/api/projects/projects/${id}/tasks`),
  createTask:      (id, body) => apiPost(`/api/projects/projects/${id}/tasks`, body),
  updateTask:      (id, body) => apiPatch(`/api/projects/tasks/${id}`, body),
  moveTask:        (id, body) => apiPatch(`/api/projects/tasks/${id}/move`, body),
  deleteTask:      (id)     => apiDelete(`/api/projects/tasks/${id}`),

  listMilestones:  (id)     => apiGet(`/api/projects/projects/${id}/milestones`),
  createMilestone: (id, body) => apiPost(`/api/projects/projects/${id}/milestones`, body),
  updateMilestone: (id, body) => apiPatch(`/api/projects/milestones/${id}`, body),
  deleteMilestone: (id)     => apiDelete(`/api/projects/milestones/${id}`),

  statusBreakdown: ()       => apiGet('/api/projects/reports/status-breakdown'),
  budgetVsActual:  (params) => apiGet('/api/projects/reports/budget-vs-actual', params),
  taskStatus:      ()       => apiGet('/api/projects/reports/task-status'),

  listTimeEntries:  (params) => apiGet('/api/projects/time-entries', params),
  createTimeEntry:  (body)   => apiPost('/api/projects/time-entries', body),
  updateTimeEntry:  (id, body) => apiPatch(`/api/projects/time-entries/${id}`, body),
  setTimeStatus:    (id, status) => apiPatch(`/api/projects/time-entries/${id}/status`, { status }),
  deleteTimeEntry:  (id)     => apiDelete(`/api/projects/time-entries/${id}`),
  hoursByProject:   (params) => apiGet('/api/projects/reports/hours-by-project', params),
  hoursByEmployee:  (params) => apiGet('/api/projects/reports/hours-by-employee', params),

  listExpenses:     (params) => apiGet('/api/projects/expenses', params),
  createExpense:    (body)   => apiPost('/api/projects/expenses', body),
  updateExpense:    (id, body) => apiPatch(`/api/projects/expenses/${id}`, body),
  setExpenseStatus: (id, status) => apiPatch(`/api/projects/expenses/${id}/status`, { status }),
  deleteExpense:    (id)     => apiDelete(`/api/projects/expenses/${id}`),
  expensesByCategory: (params) => apiGet('/api/projects/reports/expenses-by-category', params),

  listProjectAttachments:  (id)       => apiGet(`/api/projects/projects/${id}/attachments`),
  uploadProjectAttachment: (id, body) => apiPost(`/api/projects/projects/${id}/attachments`, body),
  deleteAttachment:        (id)       => apiDelete(`/api/projects/attachments/${id}`),
  downloadAttachment: async (id, filename) => {
    const res = await apiClient.get(`/api/projects/attachments/${id}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
